export type AppName = 'Calendar' | 'Mail' | 'People' | 'ToDo';

export function getAppNameFromUrl(): AppName {
    const currentUrl = window.location.href;

    if (currentUrl.includes('calendar')) {
        return 'Calendar';
    } else if (currentUrl.includes('todo')) {
        return 'ToDo';
    } else if (currentUrl.includes('people')) {
        return 'People';
    }

    // Return 'Mail' by default
    return 'Mail';
}
